import React from "react";

const ArrowNext = (props: { showArrow: boolean }) => {
  return props.showArrow ? (
    <svg
      width="46"
      height="46"
      viewBox="0 0 46 46"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M34.7329 24.2108L17.8652 41.0808C17.1958 41.7503 16.1103 41.7504 15.4409 41.0809L11.2675 36.9075C10.598 36.2381 10.598 35.1527 11.2674 34.4833L22.7496 22.9987L16.0187 16.2678L11.2676 11.5167C10.5982 10.8473 10.5982 9.76191 11.2676 9.09239L15.441 4.91906C16.1104 4.24964 17.1958 4.24964 17.8652 4.91906L29.2139 16.2678L34.7328 21.7866C35.4022 22.4561 35.4022 23.5414 34.7329 24.2108Z"
        fill="#00D8DE"
      />
      <path
        d="M29.3445 16.4037L22.7468 23.0014L20.225 20.4797L16.0185 16.2679L11.2675 11.5169C10.598 10.8475 10.598 9.76205 11.2675 9.09253L15.4404 4.91956C16.11 4.24995 17.1956 4.25013 17.865 4.91992L26.8225 13.8822L29.3445 16.4037Z"
        fill="#00A5FF"
      />
      <path
        d="M29.3444 16.4038L22.7468 23.0014L21.1469 21.3988L27.7444 14.8011L29.3444 16.4038Z"
        fill="#0087FF"
      />
      <path
        d="M44.3838 43.8961C44.0117 43.8961 43.71 44.1978 43.71 44.57V45.3262C43.71 45.6983 44.0117 46 44.3838 46C44.7559 46 45.0576 45.6983 45.0576 45.3262V44.57C45.0576 44.1978 44.7559 43.8961 44.3838 43.8961Z"
        fill="#05C1C1"
      />
      <path
        d="M40.4062 43.8961C40.0341 43.8961 39.7324 44.1978 39.7324 44.57V45.3262C39.7324 45.6983 40.0341 46 40.4062 46C40.7784 46 41.0801 45.6983 41.0801 45.3262V44.57C41.0801 44.1978 40.7784 43.8961 40.4062 43.8961Z"
        fill="#05C1C1"
      />
      <path
        d="M36.4286 43.8961C36.0565 43.8961 35.7548 44.1978 35.7548 44.57V45.3262C35.7548 45.6983 36.0565 46 36.4286 46C36.8007 46 37.1024 45.6983 37.1024 45.3262V44.57C37.1024 44.1978 36.8007 43.8961 36.4286 43.8961Z"
        fill="#05C1C1"
      />
      <path
        d="M10.2454 0.673828C10.2454 0.301695 9.94367 0 9.57153 0C9.1994 0 8.89771 0.301695 8.89771 0.673828V1.43004C8.89771 1.80218 9.1994 2.10387 9.57153 2.10387C9.94367 2.10387 10.2454 1.80218 10.2454 1.43004V0.673828Z"
        fill="#0087FF"
      />
      <path
        d="M5.59387 0C5.22174 0 4.92004 0.301695 4.92004 0.673828V1.43004C4.92004 1.80218 5.22174 2.10387 5.59387 2.10387C5.96601 2.10387 6.2677 1.80218 6.2677 1.43004V0.673828C6.2677 0.301695 5.96601 0 5.59387 0Z"
        fill="#0087FF"
      />
      <path
        d="M1.61633 0C1.2442 0 0.942505 0.301695 0.942505 0.673828V1.43004C0.942505 1.80218 1.2442 2.10387 1.61633 2.10387C1.98847 2.10387 2.29016 1.80218 2.29016 1.43004V0.673828C2.29016 0.301695 1.98847 0 1.61633 0Z"
        fill="#0087FF"
      />
    </svg>
  ) : null;
};

export default ArrowNext;
